import request from '@/utils/request'

export function getTeacher() {
    return request({
        url: 'api/getTeacher',
        method: 'get'
    })
}
export function getTeacher2() {
    return request({
        url: 'api/getTeacher?size=10000' + '&queryAllTeacher=true',
        method: 'get'
    })
}
export function getTeacher3(id) {
    return request({
        url: 'api/getTeacher?size=10000&correctSubject=' + id,
        method: 'get'
    })
}
export function putTeacherPlanStu(data) {
    return request({
        url: 'api/putTeacherPlanStu',
        method: 'put',
        data
    })
}

export function getTeacherFreeTime(parmas) {
    return request({
        url: 'api/getTeacherFreeTime?' + parmas,
        method: 'get'
    })
}

export function getTeacherInfo(id) {
    return request({
        url: 'api/teacherInfo/' + id,
        method: 'get'
    })
}

export function getTeacherFreeTimeHistory(id, parmas) { //查询教师历史任务
    return request({
        url: 'api/teacherFreeTimeHistory/' + id + `${parmas}`,
        method: 'get'
    })
}

export function getTeacherFreeTimeNow(id) { //查询教师空闲时间+未来任务
    return request({
        url: 'api/teacherFreeTimeNow/' + id,
        method: 'get'
    })
}

export function getTeacherAndStudent(query) { //查询绑定的学生
    return request({
        url: 'api/teacherAndStudent?tId=' + query,
        method: 'get'
    })
}

export function postTeacherAndStudent(data) { //绑定学生
    return request({
        url: 'api/teacherAndStudent',
        method: 'post',
        data
    })
}

export function deleteTeacherAndStudent(id) { //删除绑定的学生
    return request({
        url: 'api/teacherAndStudent/' + id,
        method: 'delete'
    })
}

export function getTeacherUserFreeTime(id, query) { //获取空闲时间
    return request({
        url: 'api/teacherFreeTime/' + id + '?day=' + query,
        method: 'get'
    })
}

export function postTeacherUserFreeTime(id, data) { //修改空闲时间
    return request({
        url: 'api/teacherFreeTime/' + id,
        method: 'post',
        data
    })
}

export function postBatchAddUserFreeTime(data) { //批量修改空闲时间
    return request({
        url: 'api/teacherFreeTime/batchAddUserFreeTime',
        method: 'post',
        data
    })
}

export function postTeacherBeiJingTime(id, data) { //修改空闲时间
    return request({
        url: 'api/teacherBeiJingTime/' + id,
        method: 'post',
        data
    })
}


export function getStudentsNumber(id, query) { //获取可带学生
    return request({
        url: 'api/studentsNumber/' + id + '?day=' + query,
        method: 'get'
    })
}

export function postStudentsNumber(id, data) { //修改可带学生
    return request({
        url: 'api/studentsNumber/' + id,
        method: 'post',
        data
    })
}

export function putTeacherInfo(id, data) { //修改教师信息
    return request({
        url: 'api/teacherInfo/' + id,
        method: 'put',
        data
    })
}

export function postKickOutUser(id) { //踢出教师
    return request({
        url: 'api/kickOutUser/' + id,
        method: 'post'
    })
}

export function postSubjectToConfigure(id, data) { //踢出教师
    return request({
        url: 'api/subjectToConfigure/' + id,
        method: 'post',
        data
    })
}

export function postTeacherAttendClass(id, data) { //老师向学生约课
    return request({
        url: 'api/teacherAttendClass/' + id,
        method: 'post',
        data
    })
}

export function postTeacherUpdateClass(id, data) { //修改已约的课
    return request({
        url: 'api/teacherUpdateClass/' + id,
        method: 'post',
        data
    })
}

export function postTeacherAttendClassNoClassIn(id, data) { //后台老师约课-不添加到classin
    return request({
        url: 'api/teacherAttendClass/noClassIn/' + id,
        method: 'post',
        data
    })
}

export function deleteTeacherClass(id, c) { //取消课程 涂莹莹写的 无法拓展
    return request({
        url: 'api/teacherClass/' + id,
        method: 'delete',
        data: {
            cancelClass: c
        }
    })
}

export function deleteTeacherClass2(id, data) { //取消课程
    return request({
        url: 'api/teacherClass/' + id,
        method: 'delete',
        data
    })
}

export function putTeacherFullTime(id, data) { //取消课程
    return request({
        url: 'api/teacherFullTime/' + id + '/' + data,
        method: 'put'
    })
}
export function getTaskFeedback(id) { //获取老师的平均评价分数
    return request({
        url: 'api/taskFeedback/' + id,
        method: 'get'
    })
}

export function getAllTaskFeedback() { //获取所有平均评价分数
    return request({
        url: 'api/taskFeedback',
        method: 'get'
    })
}
export function postAllTaskFeedback(data) { //获取所有平均评价分数
    return request({
        url: 'api/taskFeedback',
        method: 'post',
        data
    })
}

export function getTaskFeedbackByMonth(id, query) { //获取当前老师的所有评分
    return request({
        url: `api/taskFeedbackByMonth/${id}?month=` + query,
        method: 'get',
    })
}

export function putTeacherTrialClasses(id, data) { //细化体验课
    return request({
        url: `api/teacherTrialClasses/` + id,
        method: 'put',
        data
    })
}

export function getSubjectFull() { //获得科目
    return request({
        url: `api/common/getSubjectFull`,
        method: 'get',
    })
}

export function getTestTeacherFreeTime() { //获得科目
    return request({
        url: `api/testTeacherFreeTime`,
        method: 'get',
    })
}


export function getAuto(parmas) { //自动排课
    return request({
        url: `api/generate/curriculumArrangement?studentIds=` + parmas,
        method: 'get',
        parmas
    })
}



export function delAuto(id) { //取消课程
    return request({
        url: 'api/curriculumArrangement/' + id,
        method: 'delete'
    })
}


export function postAutoClass(data) { //添加自动排课
    return request({
        url: 'api/curriculumArrangement',
        method: 'post',
        data
    })
}


export function putAutoClass(data) { //修改自动排课
    return request({
        url: 'api/curriculumArrangement',
        method: 'put',
        data
    })
}

export function getTeacherClassParticular(id, date) { //查询教师指定天约课详情
    return request({
        url: `api/teacherClassParticular?id=${id}&date=${date}`,
        method: 'get',
    })
}


//给老师分配写作批改任务
export function postTeacherWritingTask(id, data) {
    return request({
        url: 'api/allotCorrectHomework/' + id,
        method: 'post',
        data
    })
}


//删除教师空闲时间监控
export function deleteTeacherFreeTime(id) {
    return request({
        url: 'api/teacherFreeTimeMonitor/' + id,
        method: 'DELETE'
    })
}

//添加教师空闲时间监控
export function postTeacherFreeTime(data) {
    return request({
        url: 'api/teacherFreeTimeMonitor',
        method: 'POST',
        data
    })
}

//修改教师空闲时间监控
export function putTeacherFreeTime(data) {
    return request({
        url: 'api/teacherFreeTimeMonitor',
        method: 'PUT',
        data
    })
}

//获取课节插班生
export function getTeacherClassTransfer(MId, taskListid) {
    return request({
        url: `api/teacherAttendClass/transfer?MId=${MId}&taskListid=${taskListid}`,
        method: 'get',
    })
}
//修改课节插班生
export function postTeacherClassTransfer(cid, data) {
    return request({
        url: `api/teacherAttendClass/transfer/${cid}`,
        method: 'POST',
        data
    })
}

//修改合同到期时间 contractExpirationDate
export function putTeacherContractExpirationDate(data) {
    return request({
        url: `api/teacherInfo/contractExpirationDate`,
        method: 'PUT',
        data
    })
}


export function putScores(id, data) {
    return request({
        url: 'api/teacherInfo/scores/' + id,
        method: 'put',
        data
    })
}